import { createContext, useState, useEffect } from "react";
import i18n from '../i18n';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const savedLanguage = localStorage.getItem('preferredLanguage');
        return savedLanguage || i18n.language;
    });
    
    useEffect(() => {
        // Sync i18n with the stored language preference on mount
        if (language) {
            i18n.changeLanguage(language);
        }
    }, [language]);
    
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('preferredLanguage', lang);
        setLanguage(lang);
    };
    
    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};